import React, { useRef, useState, useEffect } from 'react'
import html2canvas from 'html2canvas';
import { useReactToPrint } from 'react-to-print';
import "../styleCV/CV05.css"
import { Link } from 'react-router-dom';

const CV05 = () => {

    document.body.style.background = "white";

    const [Image, setImage] = useState()
    const [fname, setfname] = useState()
    const [lname, setlname] = useState()
    const [jobTitle, setjobTitle] = useState()
    const [phone, setphone] = useState()
    const [email, setemail] = useState()

    //address info
    const [street, setstreet] = useState()
    const [city, setcity] = useState()
    const [state, setstate] = useState()
    const [country, setcountry] = useState()
    const [postcode, setpostcode] = useState()

    //educational details 
    const [educationHTML, seteducationHTML] = useState()

    //summary
    const [CVDescription, setCVDescription] = useState()

    //skills 
    const [CVSkills, setCVSkills] = useState()

    //Experience
    const [experienceHTML, setexperienceHTML] = useState()

    //Project info
    // const [projectInfoHTML, setprojectInfoHTML] = useState()
    
    //achievements 
    const [CVAchievements, setCVAchievements] = useState()
    
    //languages
    const [langs, setLangs] = useState()

    useEffect(() => {
        //image photo 
        setImage(localStorage.getItem("profilePhoto"));

        //fetch objs from storage 
        const personalInfo = JSON.parse(localStorage.getItem("personalDetails"))
        //personal info
        if (personalInfo !== null) {
            setfname(personalInfo.firstname)
            setlname(personalInfo.lastname)
            setjobTitle(personalInfo.jobtitle)

            //contact info
            setphone(personalInfo.phone)
            setemail(personalInfo.email)

            //address info
            setstreet(personalInfo.address)
            setcity(personalInfo.city)
            setstate(personalInfo.state)
            setcountry(personalInfo.country)
            setpostcode(personalInfo.postcode)
        }

        //educational info
        const education = JSON.parse(localStorage.getItem("Education"));
        populateEducation(education)

        //summary
        setCVDescription(localStorage.getItem("CVDescription"));
        
        //languages
        setLangs(localStorage.getItem("cvlangs"));

        //Experience
        const experience = JSON.parse(localStorage.getItem("ProfessionalExperience"))
        populateExperience(experience);

        //skills
        const skills = JSON.parse(localStorage.getItem('skills'));
        populateSkills(skills)

        //achievements
        const achievements = JSON.parse(localStorage.getItem('achievements'));
        populateAchievements(achievements)
        
        //project Info
        // const projectInfo = JSON.parse(localStorage.getItem('projectInfo'));
        // populateProject(projectInfo);
    }, [])
    

    const populateAchievements = (achievements) => {
        if (achievements[0].achievements !== "") {
            setCVAchievements(
                <>
                    <div className="boxp05" id="Achievementsp05">
                        <h3 className="titlep05" id="Achievementstitlep05">Achievements</h3>
                        <ul className='achievementlistp05'>

                            {achievements.map((ach, index) => (

                                <li className="listitemp05">{ach.achievements}</li>

                            ))}
                        </ul>
                    </div>
                </>
            )
        }
    }

    const populateSkills = (skills) => {
        if (skills[0].skill !== "") {
            setCVSkills(
                <>
                    <div className="boxp05" id="Skillsp05">
                        <h3 className="titlep05" id="Skillstitlep05">Skills</h3>
                        <ul className='skilllistp05'>

                            {skills.map((sk, index) => (

                                <li className="listitemp05">{sk.skill}</li>

                            ))}
                        </ul>
                    </div>
                </>
            )
        }
    }

    const populateExperience = (experience) => {
        if (experience[0].WorkSummary !== "" || experience[0].StartDate !== "" || experience[0].PositionTitle !== "" || experience[0].EndDate !== "" || experience[0].ComponyName !== "") {
            setexperienceHTML(
                <>
                    <h3 className="titlep05" id="expertitlep05">Experience</h3>
                    {experience.map((exp, index) => (
                        <div key={index} className="experienceblock05">
                            <div>
                                <div className="jobtitlep05">
                                    <label>{exp.PositionTitle}</label>
                                </div>
                                <div className='companynamep05'>
                                    <span>{exp.CompanyName}</span>
                                </div>
                                <div className="durationp05">
                                    <span className="startdatep05">{exp.StartDate}</span><span>-</span><span className="lastdatep05">{exp.EndDate}</span>
                                </div>
                                <div className="descriptionp05">{exp.WorkSummary}</div>
                            </div>
                        </div>
                    ))}
                </>
            )
        }
    }

    const populateEducation = (education) => {
        if (education[0].schname !== "" || education[0].schloc !== "" || education[0].field !== "" || education[0].edustrdate !== "" || education[0].eduendate !== "" || education[0].deg !== "") {
            seteducationHTML(
                <>
                    <h3 className="titlep05" id="educationtitlep05" >Education</h3>
                    <ul class="leftsidelist1p05">
                        {education.map((edu, index) => (
                            <li>
                                <div>
                                    <h4><span>{edu.deg}</span> in <span>{edu.field}</span></h4>
                                </div>
                                <div><span>{edu.edustrdate}</span> - <span>{edu.eduendate}</span></div>
                                <div>{edu.schname}</div>
                                <div>{edu.schloc}</div>
                            </li>

                        ))}
                    </ul>
                </>
            )
        }
    }

    // const populateProject = (projectInfo) => {
    //     if (projectInfo[0].projectTitle !== "" || projectInfo[0].projectDesc !== "") {
    //         setprojectInfoHTML(
    //             <>
    //                 <div className="boxp05" id="projectp05">
    //                     <h3 className="titlep05" id="protitp05" >Project</h3>
    //                     <div className="projectsListp05">
    //                         {projectInfo.map((prj, index) => (
    //                             <div className="Pro1p05">
    //                                 <div className="protitlep05">{prj.projectTitle}</div>
    //                                 <div className="prodescripp05">{prj.projectDesc}</div>
    //                             </div>
    //                         ))}
    //                     </div>
    //                 </div>
    //             </>
    //         )
    //     }
    // }

    const table = document.getElementById('CVp05');

    const componentRef = useRef();
    const handlePrint = useReactToPrint({
        content: () => componentRef.current,
    });



    const downloadImage = () => {
        html2canvas(table).then(function (canvas) {
            const link = document.createElement('a');
            link.download = 'business.png';
            link.href = canvas.toDataURL('image/png');
            link.click();
        });
    }


    return (<>
        <div className="containerp05">

            <div className="CVp05" ref={componentRef} id="CVp05">

                <div className='upperpartp05'>
                    <div className='imgcontainerp05'>
                        <img className='userPhotop05' src={Image} alt="" />
                    </div>

                    <div className='fullnameAndPostp05'>

                        <div className='namep05'>
                            <span className='fullNamep05'><span>{fname}</span>&nbsp;<span>{lname}</span></span>
                        </div>

                        <div className='positionp05'>
                            <span className='posp05'>{jobTitle}</span>
                        </div>
                    </div>

                    <div className='boxp05' id="contactinfop05" >
                        <h3 className="titlep05" id='conttitle'>Contact</h3>

                        <ul classname="leftsidelistp05">
                            <li>
                                <span className="iconp05" id="icon1p05"><i class="fa fa-phone" aria-hidden="true"></i></span>
                                <span className="text1p05">{phone}</span>
                            </li>
                            <li className='list2p05'>
                                <span className="iconp05" id="icon2p05"><i class="fa fa-envelope-o" aria-hidden="true"></i></span>
                                <span className="text2p05">{email}</span>
                            </li>
                            {/* <li className='list3itemp05'>
                <span className="iconp05" id="icon3p05"><i class="fa fa-linkedin-square" aria-hidden="true"></i></span>
                <span className="text3p05">www.linked.com </span>
              </li> */}
                            <li className='list4p05'>
                                <span className="iconp05" id="icon4p05"><i class="fa fa-map-marker" aria-hidden="true"></i></span>
                                <div className='addresp05'>
                                    <span className="text4p05" ><span>{street}</span>, <span>{city}</span><span>, </span><span>{state}</span>, <span>{country}</span>&nbsp;(<span>{postcode}</span>)</span>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>

                <div className="lowerpartp05">

                    <div className="leftsidep05">
                        <div className='boxp05' id="Educationp05">
                            {/* <h3 className="titlep05" id="educationtitlep05" >Education</h3> */}
                            {/* <ul class="leftsidelist1p05">
                                <li>
                                    <div>
                                        <h4>Masters degree in computer science</h4>
                                    </div>
                                    <div>2051-2053</div>
                                    <div>d.y.patil university</div>
                                    <div>123 Anywhere st, Any city</div>
                                </li>
                                 
                            </ul> */}
                            {educationHTML}
                        </div>

                        {/* <div className="boxp05" id="Skillsp05">
                            <h3 className="titlep05" id="Skillstitlep05">Skills</h3>
                            <ul className='skilllistp05'>
                                <li className="listitemp05">problem solving</li>
                            </ul>
                        </div> */}
                        {CVSkills}
                        
                        {CVAchievements}
                        
                        <div className="boxp05" id="langboxp05" >
                            <h3 className="titlep05" id="langtitlep05">Languages</h3>
                            <div id="langp05" >{langs}</div>
                        </div>  


                    </div>

                    <div className="rightsidep05">
                        <div className="boxp05" id="summaryboxp05" >
                            <h3 className="titlep05" id="summarytitlep05">Summary</h3>
                            <div id="summaryp05" >{CVDescription}</div>
                        </div>

                        <div className="boxp05" id="experiencep05" >
                            {/* <h3 className="titlep05" id="expertitlep05">Experience</h3> */}
                            {/* <div className="experienceblock">
                                <div className="jobtitlep05">
                                    <label>Full stack developer</label>
                                </div>
                                <div className='companynamep05'>
                                    <span>infosys | </span><span>123,pune shivaji road</span>
                                </div>
                                <div className="durationp05">
                                    <span className="startdatep05">2021</span><span>-</span><span className="lastdatep05">present</span>
                                </div>
                                <div className="descriptionp05">Lorem ipsum dolor sit amet consectetur adipisicing elit. Nihil cumque fugit praesentium quisquam neque adipisci quidem placeat similique molestias? Velit.</div>
                            </div> */}
                            {experienceHTML}
                        </div>

                        {/* project info */}
                        {/* {projectInfoHTML} */}

                        {/* <div className="boxp05" id="projectp05"> */}
                        {/* <h3 className="titlep05" id="protitp05" >Project</h3> */}
                        {/* <div className="projectsListp05">
                                <div className="Pro1p05">
                                    <div className="protitlep05">data structure library</div>
                                    <div className="prodescripp05">Lorem ipsum dolor sit amet consectetur adipisicing elit. Laborum, vero?</div>
                                </div>

                                <div className="pro2p05">
                                    <div className='protitlep05'>chatbot</div>
                                    <div className="prodescripp05">Lorem ipsum dolor sit amet consectetur adipisicing elit. Aspernatur repellendus incidunt fuga impedit veniam.</div>
                                </div>
                            </div> */}
                        {/* </div> */}
                    </div>
                </div>
            </div>
            {/* buttons to print the document */}
            <div className="container" style={{ "width": "100%", "display": "flex", "flexDirection": "row", "alignItems": "center", "justifyContent": "center", marginTop: "40px", "gap": "30px" }}>


                <Link to="/CVform1" k><button id='eidtForm' type="button" className="btn btn-success business05-btn">EDIT FORM</button></Link>
                <button id='mybtn' onClick={handlePrint} type="button" className="btn btn-success business05-btn">Download PDF</button>
                <button onClick={downloadImage} type="button" className="btn btn-success business05-btn">Download Image</button>

            </div>
            <div
                style={{
                    display: "flex",
                    justifyContent: "center",
                    fontFamily: "kanit",
                    marginBottom: "20px",
                    marginTop: "30px"

                }}
            >
                <Link
                    to="/"
                    class="btn btn-outline-danger"
                    style={{ marginRight: "50px", width: "180px", fontSize: "18px" }}
                >
                    Back
                </Link>

                <Link to="/cv04"

                    class="btn btn-outline-success"
                    style={{ width: "180px", fontSize: "18px" }}
                >
                    Next
                </Link>

{/* <Link to="/" className="btn btn-outline-success"  >&nbsp;&nbsp;&nbsp;&nbsp;Edit form . .&nbsp;&nbsp;&nbsp;&nbsp;</Link>

<button id="mybtn" onClick={handlePrint} type="button" className="btn btn-outline-success mr-2">
  Download PDF
</button>
<button onClick={downloadImage} type="button" className="btn btn-outline-success" >
  Download Image
</button>

<Link to="/" className="btn btn-outline-success"  >&nbsp;&nbsp;&nbsp;&nbsp;Next&nbsp;&nbsp;&nbsp;&nbsp;</Link> */}

            </div>

        </div >

    </>
    )
}

export default CV05